/**
 * Shared Tailwind classes for unauthenticated auth flows so fields stay readable
 * in both light and dark mode (explicit surfaces + text; avoids UA dark inputs + dark text).
 */

export const authScreenShellClass =
  'flex justify-center items-center min-h-screen bg-gradient-to-br from-indigo-400 to-purple-600 dark:from-indigo-950 dark:to-purple-950 p-5';

export const authCardClass =
  'bg-white dark:bg-gray-800 p-10 rounded-xl shadow-2xl w-full max-w-md border border-transparent dark:border-gray-700';

/** Border colors applied separately so error states can override. */
export const authInputBaseClass =
  'w-full px-4 py-3 border-2 rounded-lg text-base bg-white text-gray-900 placeholder:text-gray-500 transition-colors duration-300 ease-in-out focus:outline-none disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-400 dark:disabled:bg-gray-950 dark:disabled:text-gray-500';

export const authInputBorderOk =
  'border-gray-300 focus:border-indigo-400 dark:border-gray-600 dark:focus:border-indigo-400';

export const authInputBorderErr =
  'border-red-400 focus:border-red-500 dark:border-red-500 dark:focus:border-red-400';

export const authInputClass = `${authInputBaseClass} ${authInputBorderOk}`;

export const authSelectClass =
  'w-full px-4 py-3 border-2 rounded-lg text-base bg-white text-gray-900 border-gray-300 transition-colors duration-300 ease-in-out focus:outline-none focus:border-indigo-400 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed dark:bg-gray-900 dark:text-gray-100 dark:border-gray-600 dark:focus:border-indigo-400 dark:disabled:bg-gray-950';

export const authLabelClass = 'block mb-2 text-gray-600 dark:text-gray-300 font-medium text-sm';

export const authErrorBannerClass =
  'text-red-600 dark:text-red-300 bg-red-100 dark:bg-red-950/50 border border-red-300 dark:border-red-800 rounded-lg p-3 mb-5 text-sm text-center';

export const authSuccessBannerClass =
  'text-green-700 dark:text-green-300 bg-green-100 dark:bg-green-950/40 border border-green-300 dark:border-green-800 rounded-lg p-3 mb-5 text-sm text-center';
